var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 7.38729 25.6127 0 16.5 0C7.3873 0 0 7.38729 0 16.5C0 24.7355 6.03378 31.5617 13.9219 32.7995V21.2695H9.73242V16.5H13.9219V12.8648C13.9219 8.72953 16.3853 6.44531 20.1542 6.44531C21.9589 6.44531 23.8477 6.76758 23.8477 6.76758V10.8281H21.7671C19.7175 10.8281 19.0781 12.1001 19.0781 13.4062V16.5H23.6543L22.9228 21.2695H19.0781V32.7995C26.9662 31.5617 33 24.7355 33 16.5Z",
    fill: "#FFF625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9228 21.2695L23.6543 16.5H19.0781V13.4062C19.0781 12.1014 19.7175 10.8281 21.7671 10.8281H23.8477V6.76755C23.8477 6.76755 21.9595 6.44528 20.1542 6.44528C16.3853 6.44528 13.9219 8.7295 13.9219 12.8648V16.5H9.73242V21.2695H13.9219V32.7995C15.6302 33.0668 17.3698 33.0668 19.0781 32.7995V21.2695H22.9228Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.126f458c.svg";
export { ForwardRef as ReactComponent };